import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
} from '@angular/core';
import { TelXLContentPreviewService } from '@dxp/components';
import { TelXLPanelComponent } from '@dxp/elements';
import { mediaIcon } from '@dxp/core/helpers';
import { IAttachmentFile } from '../attachments.component';

@Component({
    selector: 'telxl-shared-single-attachment',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TelXLPanelComponent],
    templateUrl: './single-attachment.component.html',
    styleUrl: './single-attachment.component.scss',
})
export class TelXLSingleAttachmentsComponent {
    readonly #previewService = inject(TelXLContentPreviewService);

    file = input.required<IAttachmentFile>();
    canDownload = input<boolean>(true);

    fileType = computed<string>(() => {
        return mediaIcon(this.file().name);
    });

    canPreview = computed<boolean>(() =>
        this.#previewService.canPreview(this.file().type, this.file().name),
    );

    preview() {
        if (!this.canPreview()) return;

        this.#previewService.open({
            url: this.file().url ?? '',
            contentType: this.file().type,
            fileName: this.file().name,
        });
    }

    download() {
        window.location.href = this.file().url;
    }
}
